import { pub } from "../../lib/pubThemeClasses";

/** Hafif shimmer — malzeme / kart grid beklerken */
export default function PublicCardsSkeleton({ cols = "grid-cols-1 md:grid-cols-2 lg:grid-cols-3", count = 6 }) {
  return (
    <div
      className={`grid ${cols} gap-4 overflow-hidden rounded-sm border animate-pulse ${pub.borderSubtle}`}
      role="status"
      aria-busy="true"
      aria-label="Yükleniyor"
    >
      {Array.from({ length: count }).map((_, i) => (
        <div key={i} className={`h-72 bg-neutral-200/80 dark:bg-white/[0.06] rounded-sm ${pub.softPanel}`} />
      ))}
    </div>
  );
}
